export { RoutingScheduleComponent } from './schedule.component';
